<template>
  <div id="DiscountSelect">
    <div class="selectBar" @click.stop="selectCoupon_fn" v-if="active">
      <span>{{active.title}}</span>
      <i>{{rule_cpu(active)}}</i>
      <CaretUpOutlined />
      <CaretDownOutlined />
    </div>
    <ul :class="`coupon ${optionHeight?'active':''}`" :style="`height: ${optionHeight}px`" v-if="active">
      <li v-for="(item,index) in options" :key="index" @click.stop="activeOption_fn(item,index)" :class="{'active':(active.id === item.id)}">
        <span>{{item.title}}</span>
        <i>{{rule_cpu(item,index)}}</i>
      </li>
    </ul>
  </div>
</template>

<script>
  import {CaretUpOutlined,CaretDownOutlined} from '@ant-design/icons-vue';
  export default {
    name: "DiscountSelect",
    components: {
      CaretUpOutlined,CaretDownOutlined
    },
    props:['options','isMultiple'],
    computed:{
      rule_cpu(){
        return (item,index) =>{
          if(item.preferentialType === 'MR'){
            // 满减
            return '满' + item.threshold + '减' + item.reductionAmount;
          }else if(item.preferentialType === 'DR'){
            // 直减
            return '减' + item.reductionAmount;
          }
        }
      }
    },
    data(){
      return{
        optionHeight: 0,
        active: null,
      }
    },
    inject:['discountNum_fn'],
    mounted() {
      if(this.options.length){
        let maxObj = JSON.parse(JSON.stringify(this.options)).sort(function(a,b){
          return b.reductionAmount-a.reductionAmount;
        })[0];
        this.active = maxObj;
        this.discountNum_fn(maxObj)
      }
      document.querySelector('body').addEventListener('click',(e)=>{
        if(e.target.className != 'selectBar'){
          this.optionHeight = 0;
        }
      });
    },
    watch:{
      // 当兑换券展开时discountSelect_isShow为false，隐藏兑换券下拉框
      '$store.state.discountSelect_isShow':{
        handler(n){
          if(!n){
            this.optionHeight = 0;
          }
        }
      }
    },
    methods:{
      // 显示列表
      selectCoupon_fn(){
        if(this.$store.state.discountSelect_isShow){
          this.optionHeight = 0;
          this.$store.commit('setDiscountSelect_isShow',false);
        }else{
          this.optionHeight = 36 * this.options.length;
          this.$store.commit('setDiscountSelect_isShow',true);
          this.$store.commit('setExchangeSelect_isShow',false);
        }
      },
      // 优惠券
      activeOption_fn(item,index) {
        this.optionHeight = 0;
        this.$store.commit('setDiscountSelect_isShow',false);
        this.active = item;
        this.discountNum_fn(item)
      }
    },
    beforeDestroy() {
      this.discountNum_fn()
    }
  }
</script>

<style scoped lang="scss">
  #DiscountSelect{
    position: relative;
    width: 100%;
    display: flex;
    z-index: 9;
  }
  .discountNum{
    margin-left: auto;
    color: $theme_blue;
  }
  .selectBar{
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #fff;
    line-height: 36px;
    padding: 0 32px 0 22px;
    font-size: 16px;
    border-radius: 6px;
    position: relative;
    cursor: pointer;
    flex: 1;

    i {
      color: #F76B03;
    }

    .anticon-caret-up{
      position: absolute;
      right: 12px;
      top: 8px;
      font-size: 12px;
      color: $theme_blue;
    }
    .anticon-caret-down{
      position: absolute;
      right: 12px;
      top: 15px;
      font-size: 12px;
      color: $theme_blue;
    }
  }
  .coupon {
    position: absolute;
    top: 40px;
    left: 0;
    display: flex;
    flex-direction: column;
    background: #fff;
    line-height: 36px;
    border-radius: 6px;
    font-size: 16px;
    transition-property: height, margin-top, opacity;
    transition-duration: .3s, .3s, 0s;
    opacity: 0;
    height: 0;
    overflow: auto;
    width: 100%;
    box-shadow: 0 2px 8px #00000026;
    cursor: pointer;
    max-height: 272px;
    &::-webkit-scrollbar {
      /*滚动条整体样式*/
      width: 3px; /*高宽分别对应横竖滚动条的尺寸*/
      height: 1px;
    }

    &::-webkit-scrollbar-thumb {
      /*滚动条里面小方块*/
      border-radius: 10px;
      background-color: rgba(5, 129, 206, 0.5);
      background-image: -webkit-linear-gradient(
        45deg,
        rgba(255, 255, 255, 0.2) 25%,
        transparent 25%,
        transparent 50%,
        rgba(255, 255, 255, 0.2) 50%,
        rgba(255, 255, 255, 0.2) 75%,
        transparent 75%,
        transparent
      );
    }

    &::-webkit-scrollbar-track {
      /*滚动条里面轨道*/
      box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
      background: transparent;
      border-radius: 10px;
    }

    &.active {
      /*height: 36px;*/
      opacity: 1;
      transition-property: height, opacity;
      transition-duration: .3s, .3s;
    }

    li {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 32px 0 22px;

      &.active{
        background: rgba(5, 129, 206, 0.1);
      }

      i {
        color: #F76B03;
      }
    }
  }
</style>
